module.exports = __webpack_public_path__ + "static/neufile-grotesk-regular-6ce92b5467ba50104a470522964fdb56.woff2";